module.exports = __webpack_public_path__ + "0027ee3c4fb19fafaf821d3a75fdaefb.jpg";